import buildMeta from "generated/build-meta.json";
import vars from "utils/vars";

const isStagingBuild =
	(vars.app.adminDomain || "").includes("staging") || (vars.app.domain || "").includes("staging");

const shouldLogBuildInfo = () => vars.isDevelopment || isStagingBuild;

const formatDeployTime = (deployedAt) =>
	new Date(deployedAt).toLocaleString(undefined, {
		dateStyle: "full",
		timeStyle: "long",
	});

/** Logs version and deploy timestamp to the console on staging and local dev. */
export const logBuildInfo = () => {
	if (!shouldLogBuildInfo()) return;

	const label = vars.app.name || "Taptype";
	const version = buildMeta.version || vars.app.version || "unknown";
	const deployedAt = buildMeta.deployedAt;

	if (deployedAt) {
		console.info(`[${label}] v${version} — deployed ${formatDeployTime(deployedAt)}`);
	} else {
		console.info(`[${label}] v${version}`);
	}
};
